export default __webpack_public_path__ + "static/media/070_boost.last.4508b3e5.webp";